import { render, staticRenderFns } from "./Lifecycle.vue?vue&type=template&id=22dd49ba&"
import script from "./Lifecycle.vue?vue&type=script&lang=js&"
export * from "./Lifecycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports